import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { RouteWithAuth } from '@99designs/design-services-common';
import { Submit } from '@99designs/feature-design-services-brief';
import { __ } from '@99designs/i18n';

export const SubmitRoute = ({ currentCulture }: { currentCulture: string }) => {
    const { jobId } = useParams();
    const cart = new URLSearchParams(window.location.search).get('cart');
    return (
        <RouteWithAuth>
            <Helmet>
                <title>{__('Design Services Brief')} | Vistaprint</title>
            </Helmet>
            <Submit
                willSkipCart={cart === 'false'}
                briefId={jobId as string}
                locale={currentCulture}
            />
        </RouteWithAuth>
    );
};
